import { render } from "./ComparisonRadar.vue?vue&type=template&id=255e205e&scoped=true"
import script from "./ComparisonRadar.vue?vue&type=script&lang=js"
export * from "./ComparisonRadar.vue?vue&type=script&lang=js"

import "./ComparisonRadar.vue?vue&type=style&index=0&id=255e205e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255e205e"]])

export default __exports__